{
  "name": "@vestigas/admin-portal",
  "private": true,
  "version": "0.15.0",
  "description": "Web portal for Vestigas staff to manage data and configurations of customers.",
  "type": "module",
  "scripts": {
    "build:dev": "env-cmd -e dev vite build",
    "build:dynamic": "env-cmd -e $BUILD_ENV vite build",
    "build:staging": "env-cmd -e staging vite build",
    "build": "env-cmd -e production vite build",
    "build:custom-dev": "vite build --mode development",
    "dev:local-custom": "env-cmd -e local-backend env-cmd -f .env.local --silent vite",
    "dev:local-api": "env-cmd -e local-backend vite",
    "dev:mocked": "VITE_ENV=development VITE_MOCK_ENDPOINTS=true pnpm dev",
    "dev:production-api": "env-cmd -e localhost-production-api vite",
    "dev:staging-api": "env-cmd -e localhost-staging-api vite",
    "dev": "env-cmd -e localhost-dev-api vite",
    "i18n": "pnpm i18n:extract && pnpm i18n:sync",
    "i18n:extract": "i18next-cli extract",
    "i18n:sync": "i18next-cli sync && i18next-cli types",
    "i18n:lint": "i18next-cli lint",
    "format": "oxfmt --config ../../.oxfmtrc.json",
    "lint": "pnpm format && oxlint --fix --type-aware src",
    "preview": "vite preview",
    "start": "vite preview --port 8081",
    "test:coverage": "vitest run --coverage",
    "test:e2e:ui": "playwright test --ui",
    "test:e2e": "playwright test",
    "test": "vitest --config ./vite.config.ts"
  },
  "dependencies": {
    "@codemirror/lang-json": "^6.0.2",
    "@codemirror/lang-xml": "^6.1.0",
    "@emotion/react": "catalog:",
    "@emotion/styled": "catalog:",
    "@formkit/auto-animate": "catalog:",
    "@mui/lab": "catalog:",
    "@mui/material": "catalog:",
    "@mui/system": "catalog:",
    "@mui/x-data-grid": "catalog:",
    "@mui/x-data-grid-premium": "catalog:",
    "@mui/x-data-grid-pro": "catalog:",
    "@mui/x-date-pickers": "catalog:",
    "@mui/x-date-pickers-pro": "catalog:",
    "@mui/x-license": "catalog:",
    "@plugin-web-update-notification/vite": "catalog:",
    "@reduxjs/toolkit": "catalog:",
    "@sentry/react": "catalog:",
    "@tanem/react-nprogress": "catalog:",
    "@tanstack/devtools-vite": "catalog:",
    "@tanstack/react-devtools": "catalog:",
    "@tanstack/react-form": "catalog:",
    "@tanstack/react-form-devtools": "catalog:",
    "@tanstack/react-query": "catalog:",
    "@tanstack/react-query-devtools": "catalog:",
    "@tanstack/react-router": "catalog:",
    "@tanstack/react-router-devtools": "catalog:",
    "@tanstack/react-virtual": "catalog:",
    "@tanstack/zod-adapter": "catalog:",
    "@uidotdev/usehooks": "catalog:",
    "@uiw/react-codemirror": "^4.25.4",
    "@vestigas/auth": "workspace:*",
    "@vestigas/data": "workspace:*",
    "@vestigas/logger": "workspace:*",
    "@vestigas/sentry": "workspace:*",
    "@vestigas/ui": "workspace:*",
    "@vestigas/utils": "workspace:*",
    "@xstate/store": "catalog:",
    "@xstate/store-react": "catalog:",
    "chart.js": "catalog:",
    "chartjs-adapter-dayjs-4": "catalog:",
    "chartjs-chart-sankey": "^0.14.0",
    "chartjs-plugin-zoom": "^2.2.0",
    "cn": "catalog:",
    "date-fns": "^3.6.0",
    "env-cmd": "catalog:",
    "i18next": "catalog:",
    "json-beautify": "catalog:",
    "jsonschema": "^1.5.0",
    "konva": "^10.0.12",
    "ky": "catalog:",
    "littlezipper": "catalog:",
    "lodash-es": "catalog:",
    "ms": "catalog:",
    "mutative": "catalog:",
    "oidc-react": "catalog:",
    "react": "18.3.1",
    "react-chartjs-2": "catalog:",
    "react-dom": "18.3.1",
    "react-full-screen": "^1.1.1",
    "react-hot-toast": "catalog:",
    "react-i18next": "catalog:",
    "react-image-crop": "catalog:",
    "react-json-view-lite": "catalog:",
    "react-konva": "^18.2.14",
    "react-pdf": "catalog:",
    "react-redux": "catalog:",
    "react-select": "catalog:",
    "react-xml-viewer": "^2.0.5",
    "tailwindcss": "catalog:",
    "urlcat": "catalog:",
    "uuid": "catalog:",
    "workbox-window": "catalog:",
    "xlsx": "catalog:",
    "zod": "catalog:"
  },
  "devDependencies": {
    "@playwright/test": "catalog:",
    "@sentry/vite-plugin": "catalog:",
    "@thednp/dommatrix": "catalog:",
    "@tailwindcss/vite": "catalog:",
    "@tanstack/router-plugin": "catalog:",
    "@testing-library/react": "catalog:",
    "@types/react": "catalog:",
    "@types/react-dom": "catalog:",
    "@vitejs/plugin-react": "catalog:",
    "@vitest/coverage-istanbul": "catalog:",
    "dotenv": "17.4.2",
    "i18next-cli": "catalog:",
    "jsdom": "catalog:",
    "msw": "catalog:",
    "oxfmt": "catalog:",
    "vite": "catalog:",
    "vite-plugin-compression2": "catalog:",
    "vite-plugin-i18next-loader": "catalog:",
    "vite-plugin-istanbul": "catalog:",
    "vite-plugin-pwa": "catalog:",
    "vite-plugin-svgr": "catalog:",
    "vite-plugin-webfont-dl": "catalog:",
    "vitest": "catalog:",
    "zocker": "catalog:"
  },
  "msw": {
    "workerDirectory": [
      "public"
    ]
  }
}
